import { render, staticRenderFns } from "./addLark.vue?vue&type=template&id=133f45b7"
import script from "./addLark.vue?vue&type=script&lang=js"
export * from "./addLark.vue?vue&type=script&lang=js"
import style0 from "./addLark.vue?vue&type=style&index=0&id=133f45b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports